import Image from 'next/image';
import { CSSProperties } from 'react';

interface ThreeBarLoaderProps {
  style?: CSSProperties;
  customClassWrapper?: string;
  spinnerHeightWidth?: {
    h: number;
    w: number;
  };
  isTransparent?: boolean;
}

export default function QuattrLoader({ style, customClassWrapper, spinnerHeightWidth }: ThreeBarLoaderProps) {
  return (
    <div className={`quattr-loader-wrapper ${customClassWrapper}`} style={{ ...(style || {}) }}>
      <Image
        src="/Quattr_spinner_transparent.gif"
        alt="loader"
        width={spinnerHeightWidth?.w || 40}
        height={spinnerHeightWidth?.h || 40}
        unoptimized
      />
    </div>
  );
}
